






























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { RedCapital, SelectedCountry, TitleTemplatePublic } from "@/configuration";
import GoldenCard from "@/components/beneficios/GoldenCard.vue";

@Component({
	computed: { ...mapState(["user"]) },
	metaInfo: {
		title: "Financiamiento Progresivo",
		titleTemplate: TitleTemplatePublic,
		htmlAttrs: {
			// @ts-ignore
			lang: RedCapital[SelectedCountry].Lang
		}
	},
	data() {
		return {
			navigationNext: `<i class="material-icons primary--text">arrow_forward_ios</i>`,
			navigationPrevious: `<i class="material-icons primary--text">arrow_back_ios</i>`,
			projects: [
			{
				titulo: "Gold 1",
				ico: "/images/financing/g1.png",
				color: "#d04b14",
				dato1: {
					titulo: "Requisitos",
					contenido: ['Ventas Formales sobre MM$2 mensuales', 'Filtro de Riego', 'Encuesta sensata']
				},
				dato2: {
					titulo: "$1.000.000",
					contenido: ["Monto máximo", "Cuota $217.399"]
				},
				dato3: {
					titulo: "2.9%",
					contenido: "Tasa Máxima"
				},
				dato4: {
					titulo: "5 Meses",
					contenido: "Plazo máximo"
				}
			},
			{
				titulo: "Gold 2",
				ico: "/images/financing/g2.png",
				color: "#8b8b8b",
				dato1: {
					titulo: "Requisitos",
					contenido: ['Ventas Formales sobre MM$3 mensuales', 'Filtro de Riego', 'Buen comportamiento de pago en 1º Crédito', 'Encuesta sensata', 'Terminado nivel "Comienza"']
				},
				dato2: {
					titulo: "$1.500.000",
					contenido: ["Monto máximo", "Cuota $325.023 a 5 meses"]
				},
				dato3: {
					titulo: "2.7%",
					contenido: "Tasa Máxima"
				},
				dato4: {
					titulo: "6 Meses",
					contenido: "Plazo máximo"
				}
			},
			{
				titulo: "Gold 3",
				ico: "/images/financing/g3.png",
				color: "#ff8a00",
				dato1: {
					titulo: "Requisitos",
					contenido: ['Ventas Formales sobre MM$5 mensuales', 'Filtro de Riego', 'Buen comportamiento de pago en Créditos anteriores', 'Encuesta sensata', 'Terminado nivel "Crece"']
				},
				dato2: {
					titulo: "$2.500.000",
					contenido: ["Monto máximo", "Cuota $540.270 a 5 meses (10,8%)"]
				},
				dato3: {
					titulo: "2.5%",
					contenido: "Tasa Máxima"
				},
				dato4: {
					titulo: "6 Meses",
					contenido: "Plazo máximo"
				}
			},
			{
				titulo: "Gold 4",
				ico: "/images/financing/g4.png",
				color: "#f99c7e",
				dato1: {
					titulo: "Requisitos",
					contenido: ['Ventas Formales sobre MM$7 mensuales', 'Filtro de Riego', 'Buen comportamiento de pago en Créditos anteriores', 'Encuesta sensata', 'Terminado nivel "Expande" y tener diploma']
				},
				dato2: {
					titulo: "$3.500.000",
					contenido: ["Monto máximo", "Cuota $755.516 a 5 meses (10,8%)"]
				},
				dato3: {
					titulo: "2.3%",
					contenido: "Tasa Máxima"
				},
				dato4: {
					titulo: "12 Meses",
					contenido: "Plazo máximo"
				}
			},
			{
				titulo: "Gold 5",
				ico: "/images/financing/g5.png",
				color: "#00d1a8",
				dato1: {
					titulo: "Requisitos",
					contenido: ['Ventas Formales sobre MM$10 mensuales', 'Filtro de Riego', 'Buen comportamiento de pago en Créditos anteriores', 'Encuesta sensata']
				},
				dato2: {
					titulo: "$5.000.000",
					contenido: ["Monto máximo", "Cuota $1.078.387 a 5 meses (10,8%)"]
				},
				dato3: {
					titulo: "2.1%",
					contenido: "Tasa Máxima"
				},
				dato4: {
					titulo: "12 Meses",
					contenido: "Plazo máximo"
				}
			},
			],
			options: {
				golds: {
					perPage: 3
				}
			},
		};
	},
	async mounted() {
		// @ts-ignore
		this.onResponsive();
		// @ts-ignore
		window.addEventListener("resize", this.onResponsive);
	},
	beforeDestroy() {
		// @ts-ignore
		window.removeEventListener("resize", this.onResponsive);
	},
	methods: {
		onResponsive() {
			let w = window.innerWidth;
			if (w < 600) {
				this.$data.options.golds.perPage = 1;
			} else if (w > 600 && w < 960) {
				this.$data.options.golds.perPage = 1;
			} else if (w > 960 && w < 1264) {
				this.$data.options.golds.perPage = 2;
			} else if (w > 1264 && w < 1904) {
				this.$data.options.golds.perPage = 3;
			} else if (w > 1904) {
				this.$data.options.golds.perPage = 4;
			}
		}
	},
	components: {
		GoldenCard
	}
})
export default class Financing extends Vue {}
